const { pathToRegexp, compile, parse } = require('path-to-regexp')
const { routeMap } = require('./routeMap')
const pickBy = require('lodash/pickBy')

const getLinkProps = (routeName, params) => {
  const route = routeMap[routeName]

  if (!route) {
    throw new Error(`getLinkProps(): Unknown route-name “${routeName}”.`)
  }

  // `route` can be of type `string` or of type `object`
  const isObject = typeof route === 'object'

  if (isObject) {
    // A route-object is expected to have keys for `as` and `href`
    if (!route.as) {
      throw new Error(
        `getLinkProps(): The route-object for “${routeName}” is missing an “as”-property.`
      )
    }
    if (!route.href) {
      throw new Error(
        `getLinkProps(): The route-object for “${routeName}” is missing an “href”-property.`
      )
    }
  }

  let placeholders = []
  // The query string that will be appended to the URL
  // (e.g. /some/route?hello=world)
  let queryString = ''
  // The query props that will be added to the page props and are used
  // in the path (e.q. /some/route/:hello -> /some/route/world)
  let queryProps = ''
  pathToRegexp(isObject ? route.as : route, placeholders)
  const required = k => k.modifier !== '?'
  const optional = k => k.modifier === '?'
  const requiredPlaceholders = placeholders.filter(required).map(k => k.name)
  const optionalPlaceholders = placeholders.filter(optional).map(k => k.name)
  const paramsWithoutDefinedPlaceholder = pickBy(params, (_, key) => {
    return !placeholders.filter(({ name }) => name === key).length
  })

  if (requiredPlaceholders.length > 0 && !params) {
    throw new Error(
      `getLinkProps(): You forgot to pass one or more required keys for the “${routeName}”-route.`
    )
  }

  for (let i = 0; i < requiredPlaceholders.length; i++) {
    const requiredKey = requiredPlaceholders[i]
    if (!params[requiredKey]) {
      throw new Error(
        `getLinkProps(): You forgot to pass “${requiredKey}” in the params-object.`
      )
    }
  }

  const toPath = compile(isObject ? route.as : route)
  const strings = parse(isObject ? route.href : route).filter(
    s => typeof s === 'string'
  )

  const props = {
    as: isObject ? route.as : route,
    href: isObject ? route.href : route,
  }

  if (!params) {
    if (optionalPlaceholders.length > 0) {
      // Remove all placeholders, when there’s only optional ones and
      // no params passed.
      return {
        as: strings.join(''),
        href: strings.join(''),
      }
    } else {
      return props
    }
  }

  Object.keys(paramsWithoutDefinedPlaceholder).map((key, i) => {
    const separator = i === 0 ? '?' : '&'
    return (queryString = `${queryString}${separator}${key}=${paramsWithoutDefinedPlaceholder[key]}`)
  })

  queryProps = Object.keys(params).map(key => `${key}=${params[key]}`)

  props['as'] = `${toPath(params)}${queryString}`
  props['href'] = `${strings.join('')}?${queryProps.join('&')}`

  return props
}

module.exports = {
  getLinkProps,
}
